module.exports = __webpack_public_path__ + "img/jewelrybox.5a96469.jpg";